import React from 'react'
import type { ImageProps as CloudinaryImageProps } from 'cloudinary-react'
import { Image as CloudinaryImage } from 'cloudinary-react'
import type { WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'
import classnames from 'classnames'

const styles = createStyles({
  root: {}
})

export interface ImageProps extends CloudinaryImageProps, WithStyles<typeof styles> {
  loading?: 'lazy' | 'eager'
  /**
   * Fetch at most this many pixels wide (`c_limit`). Without it, `width="auto"` (no `responsive`) puts
   * no width in the URL, so Cloudinary sends the full-resolution asset — a 40 MB PNG for a PDF page (#24842).
   */
  maxWidth?: number
}

/**
 * Widest rendition fetched for each page of a PDF attachment. Uncapped, Cloudinary sent a photo-scan
 * page as a 40 MB PNG, and the quote's PDF render timed out every time (#24842, like #23666).
 */
export const PDF_PAGE_MAX_WIDTH = 1600

class Image extends React.Component<ImageProps> {
  public render() {
    const { classes, maxWidth, ...otherProps } = this.props
    const sizing: Pick<CloudinaryImageProps, 'width' | 'crop'> = maxWidth
      ? { width: maxWidth, crop: 'limit' }
      : { width: 'auto' }

    return (
      <CloudinaryImage
        key={otherProps.publicId}
        data-testid={`cloudinary-image:${otherProps.publicId}`}
        defaultImage="placeholders:image"
        quality="auto"
        flags="progressive:semi"
        dpr="auto"
        {...otherProps}
        {...sizing}
        className={classnames(classes.root, otherProps.className)}
      />
    )
  }
}

export default withStyles(styles)(Image)
